var EntryWorkflow = require('./EntryWorkflow').default;

var AddRiderWorkflow = require('./AddRiderWorkflow').default;

module.exports = {
  EntryWorkflow: EntryWorkflow,
  AddRiderWorkflow: AddRiderWorkflow
};